import React from 'react';
// import UserNav from './userNav';
// // import UserConnect from './userConnect';

import { useParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux"
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import ReactMarkdown from 'react-markdown';

const Travel = (props) => {

    const { postId } = useParams();

    const [page, setPage] = useState([]);
    const [elements, setElements] = useState([]);
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    let pageNum = 0;
    typeof (postId) === "undefined" ? pageNum = 1 : pageNum = postId;
    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/travel/${pageNum}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                if (res.length > 0) {
                    setPage(res[0]);
                } else {
                    fetch(`${URL_COURTJUS_BACK}/travel/1`, {
                        method: 'GET',
                        headers: headers,
                    })
                        .then(response => response.json())
                        .then(res => {
                            setPage(res[0]);
                        });
                }
            });
    }, []);

    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/travelelements/${pageNum}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                setElements(res);
            });
    }, []);




    return (
        <main className="container">
            <div className="main-down"></div>
            {/* {userMenu===true && <UserNav />} */}
            {/* {userMenu===true && <UserConnect />} */}

            <h2 className="masthead-subheading">{page.pTitre}</h2>
            <section className="section-travel">
                {elements.map((q, i) =>
                    <article key={i}>
                        <div className='row'>
                            {q.eType == 'left' &&
                                <div className='col-4 d-flex align-items-center justify-content-center zone-tel-masque'>
                                    <img src={`/img/pictures/${q.ePhoto}`} alt={`Article ${page.pageNum} paragraphe ${i}`} className={`float-${q.eType}`} />
                                </div>
                            }
                            <div className='col'>
                                <h5>{q.eTitre}</h5>
                                <ReactMarkdown>{q.eText.replace(/\n/g, '  \n')}</ReactMarkdown>
                            </div>
                            {q.eType == 'right' &&
                                <div className='col-4 d-flex align-items-center justify-content-center zone-tel-masque'>
                                    <img src={`/img/pictures/${q.ePhoto}`} alt={`Article ${page.pageNum} paragraphe ${i}`} className={`float-${q.eType}`} />
                                </div>
                            }
                            <div className="stop"></div>
                        </div>
                    </article>
                )}
            </section>
        </main>

    )
}

export default Travel;